// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"49ce1584","821":"b56eb579"}[chunkId] + ".chunk.css";
};